import { Card, Tabs } from "antd";
import styled from "styled-components";

import { PageHeader } from "components/pageHeader";
import RolesTable from "features/userManagementTable/components/rolesTable";
import DeprecatedUsersTable, {
  ConsumerUsersTable,
} from "features/userManagementTable/components/usersTable";

const StyledHeader = styled(PageHeader)`
  margin-bottom: 0;
`;

export default function UserManagementTable() {
  const tabs = [
    {
      label: "Users",
      key: "users",
      children: <DeprecatedUsersTable />,
    },
    {
      label: "Roles",
      key: "roles",
      children: <RolesTable />,
    },
    {
      label: "Consumers",
      key: "consumers",
      children: <ConsumerUsersTable />,
    },
  ];

  return (
    <>
      <StyledHeader>User Management</StyledHeader>
      <Card>
        <Tabs items={tabs} />
      </Card>
    </>
  );
}
